import 'leaflet/dist/leaflet.css';
import './Nav.css'
import React, { ReactNode } from 'react'
import { BatteryRemainingData } from '../../../types/Battery';

const yellBatt = 40;

const BatteryImage = React.memo(({ battery }: { battery: number }): ReactNode => {
    const icon = battery < yellBatt
        ? '/image/modem/battery/e_batt.svg'
        : '/image/modem/battery/w_batt.svg';
    return (
        <img className='bat-box-icon' src={icon} alt="" />
    );
});
BatteryImage.displayName = 'BatteryImage';

const getBatteryText = (battery: number): string => {
    return battery < 0 ? 'nan' : `${battery}%`;
};

const Battery = React.memo(({ battery }: { battery: number }) => {
    const textStyle = battery < yellBatt ? 'addition-yell' : 'addition-white';
    return (
        <div className={`bat-box-text ${textStyle}`}>
            {getBatteryText(battery)}
        </div>
    );
});
Battery.displayName = 'Battery';

interface BatteryBoxProps {
    batteries: BatteryRemainingData[] | null;
}

function BatteryBox({ batteries }: BatteryBoxProps): ReactNode {
    return (
        <div className='bat-box'>
            {batteries === null || batteries.length === 0 ? (
                <div className='bat-ctn'>
                    <div className='bat-box-text-container'>
                        <Battery battery={-1} />
                    </div>
                    <BatteryImage battery={-1} />
                </div>
            ) : (
                batteries.map((b) =>
                    <div className='bat-ctn' key={b.id}>
                        <div className='bat-box-text-container'>
                            <Battery battery={b.remaining} />
                        </div>
                        <BatteryImage battery={b.remaining} />
                    </div>
                )
            )}
        </div>
    )
}

export default BatteryBox;